import opportunitiesExportMachine from './opportunitiesExportMachine';

export * from './opportunitiesExportMachine';
export default opportunitiesExportMachine
;